// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQu62GBsR0yc2RwmnGyvxL1a1wXl3T9GY",
  authDomain: "tshaku-chat.firebaseapp.com",
  projectId: "tshaku-chat",
  storageBucket: "tshaku-chat.firebasestorage.app",
  messagingSenderId: "220178410949",
  appId: "1:220178410949:web:82b0278eed609dc0c0efac"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)

export { db }
